import { SxProps, Theme } from '@mui/material/styles';

/**
 * Shared press affordance for tappable surfaces (cards, rows, chips): the element
 * scales down slightly while pressed. Spread into an `sx` object:
 *   sx={{ ...pressableSx, /* ... *\/ }}
 * Disabled automatically under reduced-motion.
 */
export const pressableSx: SxProps<Theme> = {
  cursor: 'pointer',
  transition: 'transform .12s ease, background-color .15s ease',
  '&:active': { transform: 'scale(0.98)' },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:active': { transform: 'none' }
  }
};
